/**
 * ActivateModalButtons component.
 */
import Container from '@components/atoms/container/modalButtons';
import Focus from '@shared/types/enums/focus';
import Modals from '@shared/types/enums/modals';
import ModalButton from '@components/elements/buttons/ui/modalButton';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { ActivateModalButtonsProps as Props } from '@shared/types/props/modal';
import { channelDown, channelUp } from '@shared/store/thunks/channels.thunk';
import { pushFocus } from '@shared/store/slices/focus.slice';
import { setModal } from '@shared/store/slices/modal.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useEffect } from 'react';

/**
 * Displays the activate modal buttons.
 */
export default function ActivateModalButtons({ allowZapping = false }: Props) {
  // ------------------------------------------------------------
  // Variables
  // ------------------------------------------------------------

  // Dispatch
  const dispatch = useAppDispatch();

  // ------------------------------------------------------------
  // Effect hooks
  // ------------------------------------------------------------

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
  }, []);

  // ------------------------------------------------------------
  // Keyboard hooks
  // ------------------------------------------------------------

  useKeyboard({
    focus: Focus.MODAL_BUTTONS,
    stopPropagation: true,
    keyDownHandler: (key: string) => {
      switch (key) {
        case 'UP':
        case 'CHANNEL_UP':
          allowZapping && dispatch(channelUp());
          break;
        case 'DOWN':
        case 'CHANNEL_DOWN':
          allowZapping && dispatch(channelDown());
          break;
        case 'SELECT':
          dispatch(
            setModal(
              allowZapping ? Modals.ANONYMOUS_ZAPPER : Modals.ANONYMOUS_GENERIC
            )
          );
          break;
      }
    },
  });

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return (
    <Container>
      <ModalButton
        focus={Focus.MODAL_BUTTONS}
        text='MODAL.ACTIVATE.BUTTONS.CANCEL'
        action={() =>
          dispatch(
            setModal(
              allowZapping ? Modals.ANONYMOUS_ZAPPER : Modals.ANONYMOUS_GENERIC
            )
          )
        }
      />
    </Container>
  );
}
